import { memo } from "react"
import { Box, Typography } from "@mui/material"
import { styles } from "./InfoCard.styles"

const VARIANT_STYLES = {
  default: {
    card: styles.card,
    iconWrapper: styles.iconWrapper,
    iconImg: styles.iconImg,
  },
  white: {
    card: styles.whiteCard,
    iconWrapper: styles.iconWrapper,
    iconImg: styles.iconImg,
  },
  info: {
    card: styles.infoCard,
    iconWrapper: styles.infoIconWrapper,
    iconImg: styles.infoIconImg,
  },
}

export const InfoCard = memo(
  ({
    icon,
    title,
    subtitle,
    linkText,
    onLinkClick,
    action,
    variant = "default",
    sx = {},
  }) => {
    const { card, iconWrapper, iconImg } =
      VARIANT_STYLES[variant] || VARIANT_STYLES.default

    const renderIcon = () => {
      if (!icon) return null
      // Check if icon is an image URL string
      if (typeof icon === "string") {
        return <Box component="img" src={icon} alt="Icon" sx={iconImg} />
      }
      // Otherwise render as a React component/Node
      const IconComponent = icon
      return typeof IconComponent === "function" ? (
        <IconComponent />
      ) : (
        IconComponent
      )
    }

    return (
      <Box sx={[card, ...(Array.isArray(sx) ? sx : [sx])]}>
        <Box sx={iconWrapper}>{renderIcon()}</Box>

        <Box sx={styles.textGroup}>
          {variant === "info" ? (
            <>
              {title && (
                <Typography variant="caption" sx={styles.infoText}>
                  {title}
                </Typography>
              )}
              {subtitle && (
                <Typography variant="caption" sx={styles.infoText}>
                  {subtitle}
                </Typography>
              )}
            </>
          ) : (
            <>
              {title && (
                <Typography variant="body2" sx={styles.title}>
                  {title}
                </Typography>
              )}
              {subtitle && (
                <Typography variant="body2" sx={styles.subtitle}>
                  {subtitle}
                </Typography>
              )}
              {linkText && (
                <Typography
                  variant="body2"
                  sx={styles.link}
                  onClick={onLinkClick}
                >
                  {linkText}
                </Typography>
              )}
            </>
          )}
        </Box>

        {action && <Box>{action}</Box>}
      </Box>
    )
  }
)

export default InfoCard
